import * as d3 from 'd3';

import { hueRangeDefault, satRangeDefault, litRangeDefault } from './colorConstants_live'; // eslint-disable-line

export default {
  methods: {
    generateColorPool(
      columns,
      hueRange = hueRangeDefault,
      satRange = satRangeDefault,
      litRange = litRangeDefault,
    ) {
      return columns.map(c => this.generateTitleColor(c[0], hueRange, satRange, litRange));
    },

    generateTitleColor(
      title,
      hueRange = hueRangeDefault,
      satRange = satRangeDefault,
      litRange = litRangeDefault,
    ) {
      return this.generateHTMLColor(title, hueRange, satRange, litRange);
    },

    generateHTMLColor(
      title,
      hueRange = hueRangeDefault,
      satRange = satRangeDefault,
      litRange = litRangeDefault,
    ) {
      const color = this.generateRGBColor(title, hueRange, satRange, litRange);
      const hexColor = [color.r, color.g, color.b].map(c => this.rgbToHex(c));
      const htmlColor = `#${hexColor.join('')}`;

      return htmlColor;
    },

    generateRGBAColor(
      title,
      opacity,
      hueRange = hueRangeDefault,
      satRange = satRangeDefault,
      litRange = litRangeDefault,
    ) {
      const color = this.generateRGBColor(title, hueRange, satRange, litRange);
      const roundedColor = [color.r, color.g, color.b].map(c => Math.round(c));

      return `rgba(${roundedColor.join()}, ${opacity})`;
    },

    generateRGBColor(
      title,
      hueRange = hueRangeDefault,
      satRange = satRangeDefault,
      litRange = litRangeDefault,
    ) {
      // Ensure we're working with a string, otherwise we'll always get
      // the same color.
      const stringTitle = String(title);

      const hueSeed = this.generateSeedFromString(stringTitle, 11);
      const hueRnd = this.generateRnd(hueSeed, hueRange[0], hueRange[1]);

      const satSeed = this.generateSeedFromString(stringTitle, 3469);
      const satRnd = this.generateRnd(satSeed, satRange[0], satRange[1]);

      const litSeed = this.generateSeedFromString(stringTitle, 2207);
      const litRnd = this.generateRnd(litSeed, litRange[0], litRange[1]);

      const color = d3.rgb(d3.hsl(hueRnd, satRnd, litRnd));
      return color;
    },

    generateRnd(n, min, max) {
      let seed = n;

      seed = (seed * 9301 * 49297) % 233280;
      const rnd = seed / 233280;

      return min + rnd * (max - min);
    },

    generateSeedFromString(string, salt) {
      let seed = 1;
      for (let i = 0; i < string.length; i += 1) {
        seed += string.charCodeAt(i) * salt; // Create a larger seed
      }

      return seed;
    },

    rgbToHex(rgb) {
      let hex = Number(Math.round(rgb)).toString(16);
      if (hex.length < 2) {
        hex = `0${hex}`;
      }
      return hex;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/colors.js